import api from "./api";

const departmentService = {
  // Institute-scoped id/name list for dropdowns. The backend has no bare
  // "/departments" route; this hits the real endpoint which returns
  // { status, message, data: [{ id, name }] } and self-scopes by role
  // (admin/super-admin via instituteId query, teacher/HOD locked to own dept).
  getDepartments: (params) =>
    api.get("/institute/get-departments-names", { params }),

  getAllDepartments: (params) => api.get("/institute/get-all-departments", { params }),

  getDepartmentById: (id) => api.get(`/departments/${id}`),

  createDepartment: (departmentData) =>
    api.post("/institute/create-department", departmentData),

  updateDepartment: (id, departmentData) =>
    api.put("/institute/update-department", departmentData, {
      params: { id },
    }),

  deleteDepartment: (id) => api.delete("/institute/delete-department", {
    params: { id },
  }),

  updateDepartmentStatus: (id, status) =>
    api.put("/institute/department-status-update", {
      status,
    }, {
      params: { id },
    }),

  getDepartmentsByInstitute: (instituteId) =>
    api.get(`/departments/institute/${instituteId}`),

  // Add cache-buster so we don't get stale 304 responses after changes
  getDepartmentNames: (instituteId) =>
    api.get(`/institute/get-departments-names`, { params: { instituteId, t: Date.now() } }),

  assignHOD: (departmentId, userId) =>
    api.post("/institute/assign-department-hod", { departmentId, userId }),

  getDepartmentTeachers: (departmentId) =>
    api.get("/institute/get-department-teachers", { params: { departmentId } }),

  getDepartmentStudents: (departmentId) =>
    api.get(`/departments/${departmentId}/students`),

  importDepartments: (fileData) =>
    api.post("/departments/import", fileData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  exportDepartments: (params) =>
    api.get("/departments/export", {
      params,
      responseType: "blob",
    }),
};

export default departmentService;
